import React, { ChangeEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, InputMui, NavHeader, Page, SubmitButton } from '../../components';

type ActionCreateDeviceVariantsProps = {
  children: ReactNode;
  searchInput: string;
  handleNext: () => void;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabledSubmit?: boolean;
};

export const ActionCreateDeviceVariants: React.FC<ActionCreateDeviceVariantsProps> = ({
  children,
  searchInput,
  handleNext,
  handleChange,
  disabledSubmit = false,
}) => {
  const { t } = useTranslation('action');
  const { t: tc } = useTranslation('common');

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader title={t('action.create.tasks.task')} />
          <Header column isUnderline>
            <InputMui
              value={searchInput}
              onChange={handleChange}
              placeholder={tc('search')}
              sx={{ marginBottom: 0 }}
              autoFocus
              clearEnabled
            />
          </Header>
        </>
      }
    >
      {children}
      <SubmitButton onClick={handleNext} disabled={disabledSubmit}>
        {tc('buttons.next')}
      </SubmitButton>
    </Page>
  );
};
